<template lang="html">
   <div class="four-o-four">
      <div class="row justify-content-md-center">
         <div class="col-md-10 col-lg-9 col-xl-8 tx-center">
            <!-- <img src="/img/four-o-four.svg" alt="" class="error-img"> -->

            <object type="image/svg+xml" data="/img/four-o-four.svg" alt="" class="error-img">
               404
            </object>

            <div class="h0 tx-primary tx-black">Oops!</div>
            <div class="h5">We cannot seem to find the page you are looking for</div>
            <div class="btn btn-primary clearfix" @click="$router.go(-1)">
               <i class="l fa fa-arrow-left"></i>
               <div class="txt l t5">Go Back!</div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   mounted(){
      Event.$emit('loader:show',false)
   }
}
</script>

<style lang="scss">
   .four-o-four{
      .error-img{
         margin: 7% 0;
         width: auto;
         height: auto;
         max-width: 60%;
      }


      .btn{
         margin: 30px 0;
         .fa{
            margin: 5px 15px 5px 0;
         }
      }
   }
</style>